import { lotFromFirestore } from '@parallel-fluidics/shared/models/lots';
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';

/**
 * Fetch the assembled lots that consumed this lot as a source bag —
 * the downstream lot hop of the genealogy graph.
 */
export default async function fetchLotsUsingSource(lotId) {
  const lotsQuery = query(
    collection(getFirestore(), 'lots'),
    where('sourceLotIds', 'array-contains', lotId),
  );
  const snapshot = await getDocs(lotsQuery);
  return snapshot.docs.map((lotDoc) => lotFromFirestore(lotDoc));
}
